export default "__VITE_ASSET__B0B2U12Y__"